import equal from "fast-deep-equal";
import { CfMap, CfValue } from "./models/custom-fields.models";

function isNullUndefinedOrEmptyString(value: CfValue): boolean {
  let isEmptyString = false;
  if (typeof value === "string") {
    isEmptyString = !value.trim();
  }

  return value === null || value === undefined || isEmptyString;
}

export const areCustomFieldsChanged = (changedCustomFields: CfMap, current: CfMap): boolean => {
  for (const key in changedCustomFields) {
    const changedAndCurrentAreNull = isNullUndefinedOrEmptyString(changedCustomFields[key]) && isNullUndefinedOrEmptyString(current[key]);
    if (!changedAndCurrentAreNull && equal(changedCustomFields[key], current[key]) === false) {
      return true;
    }
  }
  return false;
};
